/* NSI courses collection page (templates/collection.courses.json), Oct 2026.
   Starting-point picker, group filters, kit options, student videos, FAQ accordion,
   "Read more" on the SEO copy and the phone sticky bar. No dependencies. */
(function () {
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function initFinder(finder) {
    var paths = all('.nc-path', finder);
    var tip = finder.querySelector('.nc-tip');
    var tipText = finder.querySelector('.nc-tip__text');
    var filters = all('.nc-filters button', finder);
    var groups = all('.nc-group', finder);
    var cards = all('.nc-card', finder);

    function setFilter(f) {
      filters.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-f') === f); });
      groups.forEach(function (g) { g.style.display = (f === 'all' || g.getAttribute('data-g') === f) ? '' : 'none'; });
    }
    function setPath(p) {
      paths.forEach(function (b) {
        var on = b.getAttribute('data-path') === p;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      setFilter('all');
      cards.forEach(function (c) {
        var hit = p && (' ' + (c.getAttribute('data-paths') || '') + ' ').indexOf(' ' + p + ' ') > -1;
        c.classList.toggle('is-dim', !!p && !hit);
        c.classList.toggle('is-reco', !!p && !!hit);
      });
      if (tip) {
        var src = p ? finder.querySelector('.nc-path[data-path="' + p + '"] .nc-path__tip') : null;
        tip.classList.toggle('is-show', !!src);
        if (tipText) tipText.innerHTML = src ? src.innerHTML : '';
      }
    }
    paths.forEach(function (b) {
      b.addEventListener('click', function () { setPath(b.classList.contains('is-on') ? null : b.getAttribute('data-path')); });
    });
    var reset = finder.querySelector('.nc-tip__reset');
    if (reset) reset.addEventListener('click', function () { setPath(null); });
    filters.forEach(function (b) { b.addEventListener('click', function () { setFilter(b.getAttribute('data-f')); }); });
  }

  function init() {
    document.body.classList.add('nc-page');
    all('.nc-finder').forEach(initFinder);

    /* kit options: one selected per course; the card photo and button both carry it to the course page */
    all('.nc-kit').forEach(function (k) {
      k.addEventListener('click', function () {
        all('.nc-kit', k.parentNode).forEach(function (x) { x.classList.remove('is-sel'); x.setAttribute('aria-pressed', 'false'); });
        k.classList.add('is-sel'); k.setAttribute('aria-pressed', 'true');
        var card = k.closest('.nc-card');
        if (card && k.getAttribute('data-url')) all('[data-nc-go]', card).forEach(function (a) { a.setAttribute('href', k.getAttribute('data-url')); });
      });
    });

    /* student videos: load only when tapped */
    all('.nc-vid').forEach(function (el) {
      el.addEventListener('click', function () {
        var v = el.querySelector('video');
        if (!v || !v.paused) return;
        v.muted = false; v.controls = true;
        var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
        el.classList.add('is-playing');
      });
    });

    /* FAQ accordion (markup from snippets/nsi-collection-faqs.liquid). layout/theme.liquid opens every
       accordion on load, which is intended site-wide, so this only keeps one toggle and the aria state honest. */
    function syncFaq() { all('.nc-faq .accordion').forEach(function (btn) { btn.setAttribute('aria-expanded', btn.classList.contains('active') ? 'true' : 'false'); }); }
    document.addEventListener('DOMContentLoaded', function () { setTimeout(syncFaq, 0); });
    all('.nc-faq .accordion').forEach(function (btn) {
      if (btn.getAttribute('data-nc')) return;
      btn.setAttribute('data-nc', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        var open = btn.classList.toggle('active');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var panel = btn.nextElementSibling;
        if (panel) panel.style.display = open ? 'block' : 'none';
      }, true);
    });

    /* SEO copy read more */
    all('.nc-seo__more').forEach(function (b) {
      b.addEventListener('click', function () {
        var box = b.closest('.nc-seo');
        var open = box.classList.toggle('is-open');
        b.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* phone bar: "Find my course" scrolls to the starting-point picker */
    all('[data-nc-find]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector('.nc-paths') || document.getElementById('nc-finder');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
